// extracted by mini-css-extract-plugin
module.exports = {"notificationFooterContainer":"NotificationBoxFooter_notificationFooterContainer__9b75w","button":"NotificationBoxFooter_button__z1Keq"};